import React, { useRef, useState } from 'react';
import { useThemeWithUndefined } from '@rescui/ui-contexts';
import { Dropdown } from '@rescui/dropdown';
import { Menu } from '@rescui/menu';
import cn from 'classnames';
import { MenuWrapper } from './menu-wrapper.js';
import styles from './index.p.module.css.js';
const ITEM_HEIGHT_BY_SIZE = {
  s: 32,
  m: 40,
  l: 52
};
const SIZE_TO_CLASS = {
  s: styles.sizeS,
  m: styles.sizeM,
  l: styles.sizeL
};

const DropdownMenu = _ref => {
  let {
    maxVisibleItems = 5,
    size = 'm',
    children,
    iconPlacement,
    itemTag,
    tag,
    theme: themeFromProps,
    mode = 'classic',
    activateFirstItemOnOpen = false,
    wrapItemsWithLi,
    className,
    ...restProps
  } = _ref;
  const menuWrapperRef = useRef(null);
  const [height, setHeight] = useState(0);
  let itemHeightFromCss = null;

  if (menuWrapperRef.current) {
    // In theory this part of the code might cause issues with SSR.
    // But in this specific context, because of checking ref "menuWrapperRef",
    // we are sure that the value will still be "null" on the first render.
    // Therefore, the first render on the client will be the same as on the server.
    // Also, there will be no layout shifts on the following renders because
    // it's a dropdown-content and in most cases it opens only on-demand
    const menuWrapperStyles = getComputedStyle(menuWrapperRef.current);
    itemHeightFromCss = parseInt(menuWrapperStyles.getPropertyValue('--_rs-dropdown-menu-item-height'), 10) || null;
  }

  const itemHeight = itemHeightFromCss || ITEM_HEIGHT_BY_SIZE[size]; // a little buffer of 10% here

  const isMoreThanPlusOne = height > (Math.ceil(maxVisibleItems) + 1.1) * itemHeight; // half of item added to show that there is more items even if scroll bar hidden
  // in case there are only 1 more item than maxVisibleItems, show it without truncating

  const maxHeight = (Math.ceil(maxVisibleItems) + (isMoreThanPlusOne ? 0.5 : 1.5)) * itemHeight;
  const {
    maxHeight: cleanMaxHeight,
    leastMaxHeight,
    ...cleanedRestProps
  } = restProps; // cast to make runtime omit

  const theme = useThemeWithUndefined(themeFromProps);
  return /*#__PURE__*/React.createElement(Dropdown, { ...cleanedRestProps,
    closeOnTab: true,
    mode: mode,
    theme: theme,
    leastMaxHeight: itemHeight,
    maxHeight: maxHeight,
    className: cn(SIZE_TO_CLASS[size], styles.dropdownMenu, className)
  }, /*#__PURE__*/React.createElement(MenuWrapper, {
    ref: menuWrapperRef,
    onHeightUpdate: setHeight
  }, /*#__PURE__*/React.createElement(Menu, {
    size: size,
    iconPlacement: iconPlacement,
    itemTag: itemTag,
    tag: tag,
    mode: mode === 'rock' ? 'rock' : 'classic',
    "data-test": "dropdown-menu",
    "data-rs-internal": 'dropdown-menu__menu',
    className: styles.menu,
    enableKeyboardNavigation: true,
    returnFocusOnUnmount: true,
    activateFirstItem: activateFirstItemOnOpen,
    wrapItemsWithLi: wrapItemsWithLi
  }, children)));
};

export { DropdownMenu, DropdownMenu as default };
